import Vue from 'vue';
import {
  Action,
  Module, Mutation, VuexModule,
} from 'vuex-module-decorators';

import { Voucher } from './../models/voucherI';

@Module({
  namespaced: true,
})
export class VoucherStore extends VuexModule {

  private fetchingVouchers: boolean = false;

  private vouchers: Voucher[] = [];

  get getVouchers(): Voucher[] {
    return this.vouchers;
  }

  @Mutation
  private SET_FETCHING_VOUCHERS(value: boolean): void {
    this.fetchingVouchers = value;
  }

  @Mutation
  private SET_VOUCHERS(vouchers: Voucher[]): void {
    this.vouchers = vouchers;
  }

  /* @Mutation
  private UPDATE_TAJNEED(tajneed: Tajneed): void {
    let index = this.tajneed.findIndex(function(item, i) {
      return item.id === tajneed.id;
    });

    this.tajneed[index] = tajneed;
    this.tajneed = JSON.parse(JSON.stringify(this.tajneed));
  } */

  /* @Mutation
  private ADD_TAJNEED(newTajneed: Tajneed): void {
    this.tajneed.push(newTajneed);
  } */

  /* @Action({commit: 'SET_TAJNEED', rawError: true})
  private setTajneed(): any {
    return TajneedService.getTajneedAllNational()
      .then((response: any) => response.data)
      .catch((error: any) => {
        Vue.prototype.$displayServerResponse(error.response!.data);
      });
  } */
}
